import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';
import { WhoWeAreModal } from '../shared/Modals/WhoWeAreModal';

interface IHomePageFooterProps {
  toggleCreateConsultantModal: () => void;
  toggleCreateProjectModal: () => void;
  toggleLoginModal: () => void;
  toggleSignupModal: () => void;
}

export const HomePageFooter: React.SFC<IHomePageFooterProps> = ({
  toggleCreateConsultantModal,
  toggleCreateProjectModal,
  toggleLoginModal,
  toggleSignupModal,
}) => 
{ 
  const [toogle, setToogle] = React.useState({
    WhoWeAreModalIsOpen: false ,
   });
   const toggleWhoWeAreModal = () =>
    setToogle({
      WhoWeAreModalIsOpen: !toogle.WhoWeAreModalIsOpen,
    });
  
  return (
  <footer className='bg-dark p-1 p-sm-5'>
    <Row>
      <Col md='3' xs='6' className='pr-5 order-1 d-flex justify-content-center'>
        <Svg  width={128} height={64} src='logo/logo-color-white' />
      </Col>
      <Col md='3' xs='6' className='d-flex flex-column order-2'>
        <Link to='/' className='p-2' onClick={toggleCreateProjectModal}>
          <span className='text-white'>Déposez un projet</span>
        </Link>
        <Link to='/' className='p-2' onClick={toggleCreateConsultantModal}>
          <span className='text-white'>Devenez consultant</span>
        </Link>
        <Link to='/' className='p-2' onClick={toggleLoginModal}>
          <span className='text-white'>Connexion</span>
        </Link>
        <Link to='/' className='p-2' onClick={toggleSignupModal}>
          <span className='text-white'>Inscription</span>
        </Link>
      </Col>
      <Col md='3' xs='6' className='d-flex flex-column order-4 order-sm-3'>
        <Link to='/' className='p-2' onClick={toggleWhoWeAreModal}>
          <span className='text-white'>Qui sommes-nous</span>
        </Link>
        {/* <Link to='/' className='p-2'>
          <span className='text-white'>Nos expertises</span>
        </Link>
        <Link to='/' className='p-2'>
          <span className='text-white'>Actualités</span>
        </Link> */}
      </Col>
      <Col md='3' xs='6' className='d-flex flex-column  order-3 order-sm-4 mt-n6 mt-sm-0'> 
        <span
          className='text-warning text-uppercase p-2'
          style={{ fontFamily: 'Fredoka One' }}
        >
          Contactez-nous
        </span>
        <span
          className='text-white text-uppercase p-2'
          style={{ fontFamily: 'Fredoka One' }}
        >
          76 Rue Blomet
          <br />
          75015 Paris
        </span>
        <a href="mailto:contact@beadvize.fr">
        <span
          className='text-white text-uppercase p-2'
          style={{ fontFamily: 'Fredoka One' }}
        >
         contact@beadvize.fr </span></a>
       
        <span
          className='text-white text-uppercase p-2'
          style={{ fontFamily: 'Fredoka One' }}
        >
          06 64 50 22 27 <br/>
          06 62 36 56 10

        </span>
        <a
          className='text-secondary p-2'
          href='https://www.linkedin.com/company/beadvize'
          target='_blank'
          style={{ textTransform: 'none' }}
        >
          in /BEADVIZE
        </a>
      </Col>
    </Row>
    <WhoWeAreModal 
    isOpen={toogle.WhoWeAreModalIsOpen}
    toggleWhoWeAreModal={toggleWhoWeAreModal}
  />
  </footer>
  
)};



// WEBPACK FOOTER //
// ./src/components/HomePage/HomePageFooter.tsx